import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Bill } from "../model/bill/types/Bill";
import truncate from "lodash/truncate";

const getTruncatedString = (text: string = "", length: number) => {
  if (text.length > length) {
    return (
      <OverlayTrigger overlay={<Tooltip>{text}</Tooltip>} placement="top">
        <span>{truncate(text, { length })}</span>
      </OverlayTrigger>
    );
  }

  return <span>{text}</span>;
};

type FType = (bill: Bill) => void;

type Props = {
  data: Bill;
  onUpdate: FType;
  onDelete: FType;
  onDownload: FType;
  onSaveEmail: FType;
};

export const TableRowCells: React.FC<Props> = ({
  data,
  onDelete,
  onUpdate,
  onDownload,
  onSaveEmail,
}) => {
  const actions = [
    {
      key: "update",
      icon: <i className="bi bi-pencil-fill text-primary"></i>,
      onClick: () => onUpdate(data),
    },
    {
      key: "download",
      icon: <i className="bi bi-download text-secondary"></i>,
      onClick: () => onDownload(data),
    },
    {
      key: "save",
      icon: <i className="bi bi-envelope-fill text-primary"></i>,
      onClick: () => onSaveEmail(data),
    },
    {
      key: "email",
      icon: <i className="bi bi-trash-fill text-danger"></i>,
      onClick: () => onDelete(data),
    },
  ];

  return (
    <tr>
      {actions.map((action) => (
        <td className="text-nowrap" key={action.key}>
          <button
            onClick={action.onClick}
            className="d-flex justify-content-center w-100 bg-transparent border-0"
          >
            {action.icon}
          </button>
        </td>
      ))}

      <td className="text-nowrap">
        <div className="d-flex justify-content-center">
          <span>{data.billNumber}</span>
        </div>
      </td>

      <td className="text-nowrap">
        <div className="d-flex justify-content-center">
          {getTruncatedString(data.soldTo, 100)}
        </div>
      </td>

      <td className="text-nowrap">
        <div className="d-flex justify-content-center">
          <span>{new Date(data.invoiceDate).toISOString().split("T")[0]}</span>
        </div>
      </td>

      <td className="text-nowrap">
        <div className="d-flex justify-content-center">
          <span>{data.totalAmount}$</span>
        </div>
      </td>
    </tr>
  );
};
